import { create } from "zustand";

const STORAGE_KEY = "nexus_sidebar";

interface SidebarState {
  collapsed: boolean;
  mobileOpen: boolean;
  toggle: () => void;
  expand: () => void;
  setCollapsed: (collapsed: boolean) => void;
  openMobile: () => void;
  closeMobile: () => void;
}

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function persistCollapsed(collapsed: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch { /* SSR / incognito fallback */ }
}

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: readCollapsed(),
  mobileOpen: false,
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      persistCollapsed(next);
      return { collapsed: next };
    }),
  expand: () => {
    persistCollapsed(false);
    set({ collapsed: false });
  },
  setCollapsed: (collapsed) => {
    persistCollapsed(collapsed);
    set({ collapsed });
  },
  openMobile: () => set({ mobileOpen: true }),
  closeMobile: () => set({ mobileOpen: false }),
}));
